import { render, staticRenderFns } from "./ImgTip.vue?vue&type=template&id=daad1a68&scoped=true"
import script from "./ImgTip.vue?vue&type=script&lang=js"
export * from "./ImgTip.vue?vue&type=script&lang=js"
import style0 from "./ImgTip.vue?vue&type=style&index=0&id=daad1a68&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daad1a68",
  null
  
)

export default component.exports